import { Button, Tabs } from 'antd';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Enums from 'utils/EnumsManager';
import { addFolder, setActiveTab } from '../flow/actions';
import FolderItem from './FolderItem';

const TABS = Enums.REPORTS.FOLDER_TYPES_IN_ARRAY;
const { TabPane } = Tabs;

const defaultProps = {};
const propTypes = {};

class SiderTabs extends Component {
  handleTabChange = key => this.props.setActiveTab(key);
  handleAddFolderClick = type => this.props.addFolder(type);

  render() {
    const { reportFolders, dashboardFolders, searchText } = this.props;
    return (
      <Tabs
        defaultActiveKey={TABS[0]}
        className="reportListTabs mt-xlg"
        type="card"
        tabBarGutter={0}
        animated
        onChange={this.handleTabChange}
      >
        <TabPane
          tab={<FormattedMessage id="page.ReportListSider.tabs.reports" />}
          key={TABS[0]}
        >
          <Button
            size="small"
            className="report-theme-btn mb-md"
            onClick={() => this.handleAddFolderClick(TABS[0])}
            disabled={reportFolders.some(rf => rf.id === -1)}
          >
            <FormattedMessage id="page.ReportListSider.new" />
          </Button>
          {reportFolders
            .filter(
              rf => rf.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            )
            .map(rf => (
              <FolderItem key={rf.id} data={rf} />
            ))}
        </TabPane>
        <TabPane
          tab={<FormattedMessage id="page.ReportListSider.tabs.dashboards" />}
          key={TABS[1]}
        >
          <Button
            size="small"
            className="report-theme-btn mb-md"
            onClick={() => this.handleAddFolderClick(TABS[1])}
            disabled={dashboardFolders.some(df => df.id === -1)}
          >
            <FormattedMessage id="page.ReportListSider.new" />
          </Button>
          {dashboardFolders
            .filter(
              df => df.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
            )
            .map(df => (
              <FolderItem key={df.id} data={df} />
            ))}
        </TabPane>
      </Tabs>
    );
  }
}

const mapStateToProps = ({ global, reportList }) => ({
  lang: global.language,
  reportFolders: reportList.folders.report,
  dashboardFolders: reportList.folders.dashboard
});
const mapDispatchToProps = {
  addFolder,
  setActiveTab
};
SiderTabs.defaultProps = defaultProps;
SiderTabs.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiderTabs);



// WEBPACK FOOTER //
// ./src/views/ReportListSider/components/Tabs.jsx